import { useState, useEffect } from "react";
import { useGetAllModuleQuery } from "src/services/ModuleService";

const useModule = () => {
    const [module, setModule] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllModuleQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setModule(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { module, isDataLoading };
};

export default useModule;
